export function inferredCalculatorKey(section){
  if(section?.countryCode==='PL')return 'etoll-pl';
  if(section?.countryCode==='CZ')return 'myto-cz';
  if(section?.countryCode==='SK')return 'emyto-sk';
  if(section?.countryCode==='SI')return 'darsgo-si';
  if(section?.countryCode==='AT')return 'asfinag-at';
  if(section?.countryCode==='HU')return 'hugo-hu';
  return null;
}

export function calculatorMeta(key){
  return ({
    'etoll-pl':{name:'e-TOLL',button:'Uruchom e-TOLL'},
    'myto-cz':{name:'MYTO CZ',button:'Ustaw parametry i uruchom MYTO CZ'},
    'emyto-sk':{name:'eMyto Słowacja',button:'Ustaw parametry i uruchom eMyto'},
    'darsgo-si':{name:'DarsGo Słowenia',button:'Ustaw parametry i uruchom DarsGo'},
    'a1-amberone-pl':{name:'A1 AmberOne',button:'Przelicz dodatkową opłatę A1'},
    'a2-awsa-pl':{name:'A2 Autostrada Wielkopolska',button:'Przelicz dodatkową opłatę A2'},
    'a4-sam-pl':{name:'A4 Katowice–Kraków',button:'Przelicz dodatkową opłatę A4'},
    'hac-hr':{name:'HAC Chorwacja',button:'Przelicz opłatę HAC i pobierz zrzut'},
    'azm-hr':{name:'Autostrada Zagreb–Macelj',button:'Przelicz opłatę AZM i pobierz zrzut'},
    'bina-istra-hr':{name:'Bina-Istra',button:'Przelicz opłatę Bina-Istra i pobierz zrzut'},
    'autostrade-it':{name:'Autostrade Italia',button:'Przelicz włoską opłatę i pobierz zrzut'},
    'autoroutes-fr':{name:'Autoroutes France',button:'Przelicz francuską opłatę i pobierz zrzut'},
    'asfinag-at':{name:'ASFINAG',button:'Ustaw parametry i uruchom ASFINAG'},
    'hugo-hu':{name:'HU-GO',button:'Uruchom HU-GO'},
  })[key]||null;
}

